/*
 * @Author: Cao_ming
 * @Date: 2020-08-24 09:23:39
 * @LastEditTime: 2020-08-31 16:02:15
 * @LastEditors: Cao_ming
 * @FilePath: \local_merchant_React\app\components\LocalMerchant\SetMealCreate\StepOne\Form\ScenicSpotImgs\index.js
 */
import React, { Component } from 'react'
import Upload from '@common/Upload'
import { toJS } from 'mobx'
import { message } from 'hljd'

export default class extends Component {
  static defaultProps = {
    selected: []
  }

  title = item => {
    return item.title
  }

  onOk = (file, item) => {
    const { onChange, scenicSpotList, setScenicSpotList } = this.props
    const index = toJS(scenicSpotList).findIndex(f => f.id === item.id)
    if (index === -1) {
      return
    }
    const ret = [...toJS(scenicSpotList)]
    ret[index]['cover_path'] = file.clipUrl
    // 用于缓存
    setScenicSpotList(ret)
    onChange && onChange(ret.filter(f => !!f.cover_path))
  }

  onDelete = (link, item) => {
    const { onChange, scenicSpotList, setScenicSpotList } = this.props
    const index = toJS(scenicSpotList).findIndex(f => f.id === item.id)
    if (index === -1) {
      return
    }
    const ret = [...toJS(scenicSpotList)]
    ret[index]['cover_path'] = ''
    // 用于缓存
    setScenicSpotList(ret)
    onChange && onChange(ret.filter(f => !!f.cover_path))
  }

  render() {
    const { selected, value = [] } = this.props
    return (
      <>
        {selected.map((item, index) => (
          <div
            key={item.id}
            style={{
              position: 'relative',
              display: 'inline-block',
              marginRight: '24px',
              lineHeight: 'normal'
            }}
          >
            {!index && (
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '0px 4px 0px 4px',
                  width: '52px',
                  height: '22px',
                  position: 'absolute',
                  right: 0,
                  fontSize: '12px',
                  background: '#FFF2DD',
                  color: '#FF9037',
                  zIndex: 10
                }}
              >
                主景点
              </span>
            )}
            <Upload
              validate={(file, link, info) => {
                if (info.height < 500 || info.width < 500) {
                  message.error('图片宽高需大于500px')
                  return false
                } else {
                  return true
                }
              }}
              max_file_size="10mb"
              autoSizeError={true}
              aspect={500 / 500}
              clipabled
              link={(value.find(f => f.id === item.id) || {}).cover_path}
              width={120}
              height={120}
              onDelete={(file, link) => this.onDelete(link, item)}
              onCliped={file => this.onOk(file, item)}
              max={5}
              title={this.title}
              up_text="请上传套餐取景地封面图"
              iconStyle={{
                color: '#d9d9d9'
              }}
            />
            <p style={{ textAlign: 'center' }}>{item.name}</p>
          </div>
        ))}
      </>
    )
  }
}
